import React, { useState } from 'react';
import {
  Container,
  Paper,
  Tabs,
  Tab,
  Box,
  Typography,
  Divider
} from '@mui/material';
import {
  People as PeopleIcon,
  Group as GroupIcon,
  Security as SecurityIcon,
  VpnKey as AccessRequestIcon,
  MergeType as MergeIcon,
  CardMembership as LicenseIcon,
} from '@mui/icons-material';
import UserManagement from './UserManagement';
import GroupManagement from './GroupManagement';
import AccessControl from './AccessControl';
import AccessRequests from './AccessRequests';
import FamilyMergeTool from './FamilyMergeTool';
import LicenseManagement from './LicenseManagement';

// TabPanel component for handling tab content
function TabPanel({ children, value, index }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
    >
      {value === index && (
        <Box sx={{ p: { xs: 1, sm: 3 } }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const AdminPortal = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ mb: 4 }}>
        <Box sx={{ p: { xs: 2, sm: 3 } }}>
          <Typography variant="h5" component="h1" gutterBottom>
            Admin Portal
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Manage users, groups, and access controls for your organization
          </Typography>
        </Box>
        <Divider />
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab icon={<PeopleIcon />} label="Users" iconPosition="start" />
          <Tab icon={<GroupIcon />} label="Groups" iconPosition="start" />
          <Tab icon={<SecurityIcon />} label="Access" iconPosition="start" />
          <Tab icon={<AccessRequestIcon />} label="Requests" iconPosition="start" />
          <Tab icon={<MergeIcon />} label="Merge" iconPosition="start" />
          <Tab icon={<LicenseIcon />} label="Licenses" iconPosition="start" />
        </Tabs>
      </Paper>

      <TabPanel value={currentTab} index={0}>
        <UserManagement />
      </TabPanel>

      <TabPanel value={currentTab} index={1}>
        <GroupManagement />
      </TabPanel>

      <TabPanel value={currentTab} index={2}>
        <AccessControl />
      </TabPanel>

      <TabPanel value={currentTab} index={3}>
        <AccessRequests />
      </TabPanel>

      <TabPanel value={currentTab} index={4}>
        <FamilyMergeTool />
      </TabPanel>

      <TabPanel value={currentTab} index={5}>
        <LicenseManagement />
      </TabPanel>
    </Container>
  );
};

export default AdminPortal; 